import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/_authenticated/admin/campaigns')({
  component: RouteComponent,
  staticData: {
    breadcrumb: ['Evaluations']
  }
})

function RouteComponent() {
  return (<Outlet />);
}
